<template>
  <div
    class="d-flex-column justify-start align-start gap-18"
    v-if="isSpecificDungeon && !$isMobile() && !$isTablet()"
  >
    <div class="d-flex-column justify-start align-start gap-0">
      <div
        class="d-flex-column justify-start align-start gap-10"
        style="margin-top: 20px"
      >
        <p class="t-grey medium-m font-family-2 caps">
          {{ remainingDungoeons }} {{ $t("new.dungeons_remaining") }}
        </p>
        <div class="dungeons_list_container">
          <DungeonItemPicker
            v-for="dungeon in dungeons"
            :key="dungeon"
            :dungeon="dungeon"
          />
        </div>
      </div>
    </div>
  </div>

  <template v-if="isSpecificDungeon && ($isMobile() || $isTablet())">
    <button
      class="drop height-42 b-radius-35"
      style="width: 42px"
      @click="openSheet"
    >
      <HoodedIcon />
    </button>
    <ClientOnly>
      <BottomSheet ref="bottomSheet" :snap-points="['60%', '80%']">
        <template #header>
          <div class="d-flex-column justify-start align-start gap-5">
            <h4 class="t-white font-family-1 title-h5 f-w-600">
              {{ $t("new.mythic_plus_dungeons") }}
            </h4>
            <label for="" class="t-grey regular-l font-family-2">
              {{ $t("new.select_mythic_plus_dungeons") }}
            </label>
            <p
              class="t-grey medium-m font-family-2 caps"
              style="margin-top: 10px"
            >
              <span class="t-orange bold-m">{{ remainingDungoeons }}</span>
              {{ $t("new.dungeons_remaining") }}
            </p>
          </div>
        </template>
        <div
          class="d-flex-column justify-start align-start gap-0"
          style="margin-top: 20px"
        >
          <div class="d-flex-column justify-start align-start gap-10">
            <div class="dungeons_list_container">
              <DungeonItemPicker
                v-for="dungeon in dungeons"
                :key="dungeon"
                :dungeon="dungeon"
              />
            </div>
          </div>
        </div>

        <template #footer>
          <button
            @click="close"
            class="full-width primary filled height-42 t-black font-family-2 bold-xl b-radius-9"
          >
            {{ $t("app.close") }}
          </button>
        </template>
      </BottomSheet>
    </ClientOnly>
  </template>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
import DungeonItemPicker from "./DungeonItemPicker.vue";
import { ref, computed } from "vue";
import "@douxcode/vue-spring-bottom-sheet/dist/style.css";
import BottomSheet from "@douxcode/vue-spring-bottom-sheet";
import HoodedIcon from "~/components/icons/HoodedIcon.vue";
const { isMobile, isTablet } = useDevice();
const bottomSheet = ref();
const openSheet = () => {
  bottomSheet.value?.open();
};

const close = () => {
  bottomSheet.value?.close();
};
const props = defineProps({
  src: {
    default: "",
  },
});

const { currentGameSlug } = useGameComposable();
const { getLocale } = useFunctions();
const { getGamePack } = useGameStore();
const checkoutStore = useCheckoutStore();
const { getUserCurrencyCode } = useUserStore();
const dungeons = ref([]);
const dungeonSeason = ref("");

const remainingDungoeons = computed(() => {
  const totalAvail = checkoutStore.getDetails?.numberOfMythic;

  if (totalAvail) {
    let selectedDungeons = checkoutStore.getSelectedDungeons;
    if (selectedDungeons?.length > 0) {
      selectedDungeons = selectedDungeons.reduce(
        (sum, item) => sum + item.numberOfDungeons,
        0
      );
      return totalAvail - selectedDungeons;
    }
    return totalAvail;
  }
  return 0;
});
const dungeonOptions = computed(() => {
  if (getGamePack?.pack_extra_options) {
    return getGamePack?.pack_extra_options?.filter(
      (opt) => opt.description === "dungeon"
    );
  }
  return [];
});
const isSpecificDungeon = computed(() => {
  if (checkoutStore.getPackExtraOptions?.dungeon) {
    return (
      checkoutStore.getPackExtraOptions?.dungeon === dungeonOptions.value[1]?.id
    );
  }
  return false;
});

const selectDungeon = (packOption) => {
  checkoutStore.setPackExtraOptions({
    dungeon: packOption.id,
  });
};

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return "";
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${getUserCurrencyCode}`;
  } else {
    return `+${packOption.price}`;
  }
};

const { data: response, error } = await useApiFetch(
  `/api/get-mmo-game-dungeons/${currentGameSlug}`,
  {
    fetchKey: "get-mmo-game-dungeons",
  }
);
if (response.value?.data) {
  dungeonSeason.value = response.value?.data?.current_season;
  dungeons.value = response.value?.data?.dungeons;
}

// watch(
//   () => isSpecificDungeon.value,
//   (newVal, oldVal) => {
//     if (oldVal !== undefined && newVal && (isMobile || isTablet)) {
//       nextTick(() => {
//         openSheet();
//       });
//     }
//   }
// );
</script>
